import { InsightCardType } from '../types';
export const cardConfigs = {
    [InsightCardType.CART_ABANDONMENT]: {
        title: 'strategic-insights.category-action.cart-abandonment.title',
        image: 'insight-cart.svg',
        tooltip: 'strategic-insights.category-action.cart-abandonment.tooltip',
        hint: 'strategic-insights.category-action.cart-abandonment.hint',
        description: [
            'strategic-insights.category-action.cart-abandonment.description.first',
            'strategic-insights.category-action.cart-abandonment.description.second',
        ],
    },
    [InsightCardType.CROSS_SELL]: {
        title: 'strategic-insights.category-action.cross-sell.title',
        image: 'insight-bags.svg',
        tooltip: 'strategic-insights.category-action.cross-sell.tooltip',
        hint: 'strategic-insights.category-action.cross-sell.hint',
        description: [
            'strategic-insights.category-action.cross-sell.description.first',
            'strategic-insights.category-action.cross-sell.description.second',
        ],
    },
    [InsightCardType.PRODUCT_REPLENISHMENT]: {
        title: 'strategic-insights.category-action.product-replenishment.title',
        image: 'insight-replenishment.svg',
        tooltip: 'strategic-insights.category-action.product-replenishment.tooltip',
        hint: 'strategic-insights.category-action.product-replenishment.hint',
        description: [
            'strategic-insights.category-action.product-replenishment.description.first',
            'strategic-insights.category-action.product-replenishment.description.second',
        ],
    },
};
